import type { AuthUser } from "@/features/auth/api";

/**
 * Public profile path segment for `/{locale}/u/[username]`.
 */
export function toPublicProfileSlug(user: AuthUser): string {
  const canonical = user.username?.trim().toLowerCase();
  if (canonical) return canonical;

  const name = user.name.trim();
  const ascii = name
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  if (ascii.length >= 2) return ascii.slice(0, 48);
  const local = user.email?.split("@")[0] ?? "user";
  const fromEmail = local.replace(/[^a-z0-9._-]/gi, "-").replace(/^-+|-+$/g, "");
  return (fromEmail.slice(0, 48) || "user").toLowerCase();
}

export function userInitials(user: AuthUser): string {
  const parts = user.name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    const a = parts[0]?.[0];
    const b = parts[1]?.[0];
    if (a && b) return `${a}${b}`.toUpperCase();
  }
  if (parts.length === 1) {
    const w = parts[0]!;
    if (w.length >= 2) return w.slice(0, 2).toUpperCase();
    if (w.length === 1) return w.toUpperCase();
  }
  const c = user.email?.[0] ?? "?";
  return c.toUpperCase();
}
